import { CarCrash, DirectionsCarFilled, Garage } from '@mui/icons-material';
import { Box, Grid } from '@mui/material';
import StatBox from 'components/StatBox';
import React from 'react';
import { useGetInventoryStatsQuery } from 'state/api';

const Cards = () => {
  const { data, isLoading } = useGetInventoryStatsQuery();

  return (
    <Box
      sx={{
        m: 2,
        ml: 0,
      }}
    >
      {/* make hieght and width same for all statbox */}

      <Grid
        container
        spacing={4}
        className='flex justify-start'
        sx={{
          height: '100%',
          width: '100%',
        }}
      >
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Total Cars'
            value={isLoading ? '-' : data?.total}
            icon={<DirectionsCarFilled />}
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Sold Cars'
            value={isLoading ? '-' : data?.sold}
            icon={<DirectionsCarFilled />}
            // different colors for all cards
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-white'
            title='Available Cars'
            value={isLoading ? '-' : data?.available}
            icon={<DirectionsCarFilled />}
            color='#1F509A'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border border-[#1F509A]'
            title='Archived Cars'
            value={isLoading ? '-' : data?.archived}
            icon={<Garage />}
            // color suitable for archived cars
            color='#D4EBF8'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border-[#1F509A]'
            title='Pending Approval'
            value={isLoading ? '-' : data?.pending}
            icon={<CarCrash />}
            color='#D4EBF8'
          />
        </Grid>
        <Grid item lg={3}>
          <StatBox
            className='text-[#1F509A] border-[#1F509A]'
            title='Rejected Cars'
            value={isLoading ? '-' : data?.rejected}
            icon={<DirectionsCarFilled />}
            color='#D4EBF8'
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Cards;
